import { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import Icon from '../../assets/icons/Icon';
import { useDict } from '../../contexts/LanguageContext';
import en from 'date-fns/locale/en-GB';
import th from 'date-fns/locale/th';

const CustomDatePicker = forwardRef((props, ref) => (
    <button
        ref={ref}
        type="button"
        style={{ borderRadius: '25px', border: '1px solid #dddddd', padding: '0.75rem' }}
        {...props}
    >
        {props.value || <p className="text-black-50">{props.placeholder}</p>}
        <Icon icon="Calendar" width={20} color="#226ef4" />
    </button>
));

CustomDatePicker.displayName = 'CustomDatePicker';

const DatePickerFinal = (props) => {
    const { input, meta, 'data-cy': dataCy, className, wrapperClassName } = props;

    const dict = useDict();

    return (
        <div className={`form__form-group-input-wrap ${className}`}>
            <div className="date-picker">
                <DatePicker
                    className="w-100 d-flex justify-content-between align-items-center bg-white"
                    name={input.name}
                    selected={input.value}
                    onChange={input.onChange}
                    dateFormat="yyyy-MM-dd"
                    dropdownMode="select"
                    autoComplete="off"
                    placeholderText={dict.enterTransactionDate}
                    filterDate={(date) => {
                        // date become null when user type in 1000 manually
                        // do this to prevent error
                        if (date) {
                            return new Date().getTime() > date.getTime();
                        }
                        return false;
                    }}
                    customInput={<CustomDatePicker />}
                    wrapperClassName={wrapperClassName}
                    data-cy={dataCy}
                    locale={localStorage.getItem('language') === 'en' ? en : th}
                />
            </div>
            {meta.error && meta.touched && (
                <span
                    className="form__form-group-error"
                    style={{ textAlign: 'justify' }}
                    data-cy={`${dataCy}--error`}
                >
                    {meta.error}
                </span>
            )}
        </div>
    );
};

DatePickerFinal.defaultProps = {
    meta: {
        touched: false,
        error: '',
    },
    'data-cy': undefined,
};

export default DatePickerFinal;
